export default __webpack_public_path__ + "static/img-01-4979d60433d8b4b7a97f0cc9d0ba83e1.png";